import $ from 'jquery';
import plugin from '../../lib/plugin';

import hoverLabel from './hover-label';

const ELEMENT_SELECTOR = '[data-hover-label]';
const PLUGIN_NAME = 'hoverLabel';

export function exec () {
    $(() => {
        $(ELEMENT_SELECTOR).each(function() {
            plugin(PLUGIN_NAME, hoverLabel);
            $(this)[PLUGIN_NAME]();
        });
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/hover-label/index.js